import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { CreateSectorUseCaseInterface } from 'domain/usecases';

export class RemoteCreateSector implements CreateSectorUseCaseInterface {
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: CreateSectorUseCaseInterface.Params,
  ): Promise<CreateSectorUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      body: params,
      method: 'post',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.created:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
